import {
  Button, Form, message, Space, Tree,
} from 'antd';
import {
  useParams,
} from 'react-router-dom';
import { useEffect, useState } from 'react';
import PaymentDetailsForm from '../../../../forms/PaymentDetailsForm';
import {
  cancelPaymentStatementService,
  getNativeInfoService,
  getPaymentService,
  getPaymentStatementService,
} from '../../../../services/paymenSevices';
import AdminPaymentRefundModal from '../../../../modals/adminPaymentRefundModal/AdminPaymentRefundModal';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function PaymentDetails() {
  const { trans } = useTranslation();
  const [form] = Form.useForm();

  const { id } = useParams();

  const [paymentTreeData, setPaymentTreeData] = useState([]);
  const [statementTreeData, setStatementTreeData] = useState([]);

  const refundedAmount = Form.useWatch('refunded_amount', form);
  const amount = Form.useWatch('amount', form);
  const isRefunded = refundedAmount >= amount;
  const [showRefundModal, setShowRefundModal] = useState(false);

  const fetchData = async () => {
    const res = await getPaymentService(id);
    form.setFieldsValue({
      amount: res?.amount,
      status: res?.status,
      payment_url: res?.payment_url,
      refunded_amount: res?.refunded_amount || 0,
      id: res?.id,
      payment_id: res?.payment_id,
      email: res?.statement?.customer?.email,
      phone_number: res?.statement?.customer?.phone_number,
      name: res?.statement?.customer?.name,
    });
  };

  function formatTreeData(data, parentKey = '') {
    return Object.entries(data).map(([key, value]) => {
      const fullKey = parentKey ? `${parentKey}.${key}` : key;
      if (typeof value === 'object' && value !== null) {
        if (Array.isArray(value)) {
          if (value.length > 0 && typeof value[0] === 'string') {
            return {
              title: key,
              key: fullKey,
              children: value.map((item, index) => ({
                title: `[${index}]: ${item}`,
                key: `${fullKey}[${index}]`,
              })),
            };
          }

          return {
            title: key,
            key: fullKey,
            children: value.map((item, index) => ({
              title: `${key}[${index}]`,
              key: `${fullKey}[${index}]`,
              children: formatTreeData(item, `${fullKey}[${index}]`),
            })),
          };
        }

        return {
          title: key,
          key: fullKey,
          children: formatTreeData(value, fullKey),
        };
      }

      return {
        title: `${key}: ${value}`,
        key: fullKey,
      };
    });
  }

  const fetchInfo = async (setState, service) => {
    try {
      setState(false);
      const res = await service(id);
      setState(formatTreeData(res));
    } catch {
      message.error('მონაცემების წამოღება ვერ ხერხდება');
      setState([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCancel = async () => {
    await cancelPaymentStatementService(id);
    fetchData();
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <div className="flex gap-4 items-center">
        <Button
          type="primary"
          onClick={handleCancel}
        >
          {trans('cancel_statement')}
        </Button>
        <Button
          type="primary"
          onClick={() => setShowRefundModal(true)}
          disabled={isRefunded}
        >
          {trans('return_money')}
        </Button>
      </div>
      <PaymentDetailsForm form={form} />

      <Button
        type="primary"
        loading={paymentTreeData === false}
        onClick={() => fetchInfo(setPaymentTreeData, getNativeInfoService)}
      >
        {trans('additional_data')}
      </Button>

      {paymentTreeData.length > 0 && (
      <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
        <Tree
          defaultExpandAll
          treeData={paymentTreeData}
          style={{ maxWidth: '100%', overflowY: 'auto' }}
        />
      </div>
      )}
      <Button
        type="primary"
        loading={statementTreeData === false}
        onClick={() => fetchInfo(setStatementTreeData, getPaymentStatementService)}
      >
        {trans('statement_data')}
      </Button>

      {statementTreeData.length > 0 && (
      <div style={{ maxWidth: '100%', overflowX: 'hidden' }}>
        <Tree
          defaultExpandAll
          treeData={statementTreeData}
          style={{ maxWidth: '100%', overflowY: 'auto' }}
        />
      </div>
      )}
      <AdminPaymentRefundModal
        show={showRefundModal}
        setShow={setShowRefundModal}
        maxAmount={amount - refundedAmount}
        refetchData={fetchData}
      />
    </Space>
  );
}
export default PaymentDetails;
